import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding } from "./lspSlice";
import {
  fetchCities,
  fetchStates,
} from "../../../components/entities/address/addressesSlice";
function validNumber(x) {
  const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
  return out;
}
const useLspAddress = () => {
  const dispatch = useDispatch();

  const { activeIndex, tradingdata, statesarray, cityarray } = useSelector(
    (state) => state.lsponboarding,
  );

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, tradingdata]);

  const handleEnableNext = () => {
    if (activeIndex === 1) {
      if (
        tradingdata?.country?.code &&
        tradingdata?.address_line_1 &&
        tradingdata?.postalcode &&
        validNumber(tradingdata?.postalcode)
      ) {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };

  useEffect(() => {
    handleStateOption();
  }, [tradingdata?.country]);

  useEffect(() => {
    handleCitiesOptions();
  }, [tradingdata?.state]);

  const handleStateOption = () => {
    const countryCode = tradingdata?.country?.code;
    if (countryCode) {
      dispatch(fetchStates(countryCode)).then((response) => {
        const options = response.payload.map((state) => ({
          name: state.label,
          code: state.value,
        }));
        dispatch(setLspOnboarding({ key: "statesarray", value: options }));
        dispatch(
          setLspOnboarding({
            key: "tradingdata",
            value: { ...tradingdata, state: "", city: "" },
          }),
        );
      });
    }
  };

  const handleCitiesOptions = () => {
    const countryCode = tradingdata?.country?.code;
    const stateCode = tradingdata?.state?.code;
    if (stateCode && countryCode) {
      dispatch(fetchCities([countryCode, stateCode])).then((response) => {
        const cityOptions = response.payload.map((city) => ({
          name: city.label,
          code: city.value,
        }));
        dispatch(setLspOnboarding({ key: "cityarray", value: cityOptions }));
        dispatch(
          setLspOnboarding({
            key: "tradingdata",
            value: { ...tradingdata, city: "" },
          }),
        );
      });
    }
  };

  const onChangeAddress = (name, value) => {
    dispatch(
      setLspOnboarding({
        key: "tradingdata",
        value: { ...tradingdata, [name]: value },
      }),
    );
  };

  return {
    onChangeAddress,
    tradingdata,
    statesarray,
    cityarray,
  };
};

export default useLspAddress;
